import { useContext } from "react";
import PropTypes from "prop-types";
import classNames from "classnames/bind";
import styles from "./WareHouse.module.css";
import { LisencePlateManagerContext } from "../../../../contexts";
import { actions } from "../../../../store";

const cx = classNames.bind(styles);
const Camera = ({ name, status, check, camID, prioritized ,index}) => {
  const { cameraCode, setCameraCode, setName, dispatch } = useContext(LisencePlateManagerContext)
  const handleGetPlayBack = (code, name) => {
    setCameraCode(code)
    setName(name)
    let data = {
      path: null,
      nameCamera: null,
      nameNotification: null,
      codeCamera: null,
      time: null,
    }
    dispatch(actions.getPathNotification(data))
  }
  return (
    <div className={cx("item-cam", camID === cameraCode ? "active" : "")} onClick={(e) => handleGetPlayBack(camID, name)}>
      <div className={cx("camera")}>
        <span className={cx("hover")}>
          <div className={cx('ai')} style={status === 'On' ? {color: '#0040FF'} : {color: '#FF3300'}}>AI</div>
          <div className={cx("tooltip",index ===0 ? "bottom":"top")}>
            {status === "On" ? "Đang bật" : "Đang tắt"}
          </div>
        </span>
        <span className={cx("name")}>{name}</span>
      </div>
    </div>
  );
};
Camera.propTypes = {
  name: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  check: PropTypes.bool.isRequired,
  camID: PropTypes.string.isRequired,
  prioritized: PropTypes.string
};
export default Camera;
